module.exports = __webpack_public_path__ + "media/images/promo/championship/digits/7-fc1b0214fd953377429f647612331af3.png";